
import { Terrace } from '@/types/terrace';

export const mockTerraces: Terrace[] = [
  {
    id: '1',
    name: 'Mälarpaviljongen',
    address: 'Norr Mälarstrand 64, 112 35',
    lat: 59.3309,
    lng: 18.0134,
    photo_url: 'https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07',
    sunStatus: 'sunny',
    openingHours: '11:00 - 23:00',
    orientation: 'Southwest',
    hasFood: true,
    petFriendly: true,
    servesAlcohol: true,
    terraceDescription: 'Floating bar and restaurant with a large terrace that gets afternoon and evening sun.',
    website: 'https://malarpaviljongen.se',
    phone: '+46 8 650 87 01',
    type: 'restaurant',
    slug: 'malarpaviljongen'
  },
  {
    id: '2',
    name: 'Trädgården',
    address: 'Hammarby Slussväg 2, 118 60',
    lat: 59.3065,
    lng: 18.0863,
    photo_url: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05',
    sunStatus: 'sunny',
    openingHours: '17:00 - 03:00',
    orientation: 'South',
    hasFood: true,
    petFriendly: false,
    servesAlcohol: true,
    terraceDescription: 'Large outdoor venue with multiple bars and food vendors.',
    website: 'https://tradgarden.com',
    type: 'bar',
    slug: 'tradgarden'
  },
  {
    id: '3',
    name: 'Blique Rooftop Bar',
    address: 'Gävlegatan 18, 113 30',
    lat: 59.3471,
    lng: 18.0487,
    photo_url: 'https://images.unsplash.com/photo-1518495973542-4542c06a5843',
    sunStatus: 'soon',
    openingHours: '16:00 - 01:00',
    orientation: 'West',
    hasFood: true,
    petFriendly: false,
    servesAlcohol: true,
    terraceDescription: 'Trendy rooftop bar with panoramic views and a relaxed atmosphere.',
    type: 'bar',
    slug: 'blique-rooftop-bar'
  },
  {
    id: '4',
    name: 'Nytorget 6',
    address: 'Nytorgsgatan 6, 116 40',
    lat: 59.3123,
    lng: 18.0801,
    sunStatus: 'sunny',
    openingHours: '11:00 - 22:00',
    orientation: 'Southeast',
    hasFood: true,
    petFriendly: true,
    servesAlcohol: true,
    terraceDescription: 'Cozy café with a small terrace facing the square, perfect for morning sun.',
    type: 'cafe',
    slug: 'nytorget-6'
  },
  {
    id: '5',
    name: 'Skeppsholmen',
    address: 'Skeppsholmen, 111 49',
    lat: 59.3255,
    lng: 18.0833,
    sunStatus: 'not-sunny',
    openingHours: '11:00 - 22:00',
    orientation: 'Southwest',
    hasFood: true,
    petFriendly: false,
    servesAlcohol: true,
    terraceDescription: 'Waterfront restaurant with a large terrace and spectacular views of Stockholm.',
    type: 'restaurant',
    slug: 'skeppsholmen'
  },
  {
    id: '6',
    name: 'Hornstulls Strand',
    address: 'Hornstulls Strand 4, 117 39',
    lat: 59.3157,
    lng: 18.0291,
    sunStatus: 'soon',
    openingHours: '11:00 - 21:00',
    orientation: 'West',
    hasFood: true,
    petFriendly: true,
    servesAlcohol: true,
    terraceDescription: 'Collection of food trucks and bars along the waterfront with sunset views.',
    type: 'food court',
    slug: 'hornstulls-strand'
  },
  {
    id: '7',
    name: 'Kungsträdgården',
    address: 'Kungsträdgården, 111 47',
    lat: 59.3312,
    lng: 18.0710,
    sunStatus: 'sunny',
    openingHours: '10:00 - 20:00',
    orientation: 'South',
    hasFood: true,
    petFriendly: true,
    servesAlcohol: false,
    terraceDescription: 'Central park with cafés and open-air seating, sunny throughout the day.',
    type: 'cafe',
    slug: 'kungstradgarden'
  },
  {
    id: '8',
    name: 'TAK Stockholm',
    address: 'Brunkebergstorg 4, 111 51',
    lat: 59.3307,
    lng: 18.0686,
    sunStatus: 'not-sunny',
    openingHours: '15:00 - 00:00',
    orientation: 'West',
    hasFood: true,
    petFriendly: false,
    servesAlcohol: true,
    terraceDescription: 'Rooftop restaurant and bar with stunning city views and evening sun.',
    type: 'restaurant',
    slug: 'tak-stockholm'
  }
];
